var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShop = function SvgShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.248.625c.578 0 1.084.434 1.229 1.012.867 2.746 3.54 4.77 6.648 4.77 3.035 0 5.709-2.024 6.576-4.77.145-.578.65-1.012 1.229-1.012h.867c1.662 0 3.252.578 4.48 1.662l9.106 7.588c.506.361.795.94.795 1.59.072.65-.145 1.228-.506 1.734l-4.047 4.625c-.867.94-2.313 1.012-3.252.217l-3.685-3.107V33a4.61 4.61 0 0 1-4.626 4.625H17.188c-2.601 0-4.625-2.023-4.625-4.625V14.934L8.806 18.04c-.94.795-2.385.723-3.252-.217L1.506 13.2c-.361-.506-.578-1.084-.506-1.734 0-.65.29-1.229.795-1.59L10.9 2.287C12.201 1.203 13.72.625 15.38.625h.868Z",
    fill: "#3C8047"
  })));
};
export default SvgShop;